import {ModifyTileStoreFunctionType, Tile, TileCoordinates, TileCoordinateType, TileData} from "./Tile";
import {GRID_LENGTH, GridSpotType, INITIAL_TYPE_GRID} from "./constants";


function tileTypeBackgroundText(type: GridSpotType): string {
    switch (type) {
        case GridSpotType.NORMAL:
            return null;
        case GridSpotType.DOUBLE_WORD:
            return 'Double Word Score';
        case GridSpotType.DOUBLE_LETTER:
            return 'Double Letter Score';
        case GridSpotType.TRIPLE_LETTER:
            return 'Triple Letter Score';
        case GridSpotType.TRIPLE_WORD:
            return 'Triple Word Score';
        case GridSpotType.START:
            return '★';
    }

    return 'No tile match?';
}

function GridSpot(props: {spotType: GridSpotType, modifyFunction: ModifyTileStoreFunctionType, tile?: TileData, i:number; j:number}) {
    const spotType = props.spotType;
    const tileData: TileData = props.tile;

    let gridSpotClass;
    let contents = [];

    function onDrop(e){
        if(tileData != null){
            // don't allow drop
            return;
        }

        const newTileData: TileData = JSON.parse(e.dataTransfer.getData("scrapple/tile"));
        newTileData.isEphemeral = true;

        const coordinates: TileCoordinates = {
            index: props.i * GRID_LENGTH + props.j,
            location: TileCoordinateType.GRID
        };

        console.log({coordinates});

        props.modifyFunction(coordinates, newTileData);

        e.preventDefault();
    }

    const gridSpotText = tileTypeBackgroundText(spotType);
    if(gridSpotText != null){
        contents.push(<span key={1}>{gridSpotText}</span>);
    }

    gridSpotClass = `tile-spot ${spotType}`;

    if (tileData != null) {
        contents.push(<Tile key={2} data={tileData} modifyTileStore={props.modifyFunction} />);
    }



    return <div className={gridSpotClass} onDrop={onDrop} onDragOver={(e) => e.preventDefault()}>{contents}</div>;

}

export function Grid(props: {grid_tiles: Array<TileData>, modifyTileStore: ModifyTileStoreFunctionType}) {
    const typeGrid = INITIAL_TYPE_GRID;

    const tiles = [];
    for (let i = 0; i < GRID_LENGTH; i++) {
        for (let j = 0; j < GRID_LENGTH; j++) {
            const key = i * GRID_LENGTH + j;
            const tileSpotType: GridSpotType = typeGrid[key];
            const tileData: TileData = props.grid_tiles[key];
            tiles.push(
                <GridSpot
                    key={key}
                    spotType={tileSpotType}
                    tile={tileData}
                    i={i}
                    j={j}
                    modifyFunction={props.modifyTileStore}
                    />
            );
        }
    }

    return (
        <div className="board-grid">
            {tiles}
        </div>
    );
}

